import { styled } from '@mui/material';
import React from 'react';

const Scrollable = styled('div')({
  paddingRight: 4,
  marginRight: -4,
  overflow: 'auto',
  height: `180px`,
  width: '100%',
  border: '0.5px solid black',
  padding: 8,
});

const ScrollContainer = styled('div')({
  height: '180px',
  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

const ScrollableSections = ({ style = {}, children }) => {
  return (
    <ScrollContainer style={style}>
      <Scrollable>{children}</Scrollable>
    </ScrollContainer>
  );
};
export { ScrollableSections };
